import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';
import { TouchableWithoutFeedback, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { getDropdownItems } from './constants';
import { DropdownList } from './List';
import { useDialog } from '@/hooks/useDialog';
import { localLogoutUser, serverLogoutUser } from '@/hooks/useAuth';
import { getAccessToken } from '@/stores/auth/services';
import { PREPARED_DIALOGS } from '@/components/ui/shared/Dialog/constants';
import { styles } from './CustomDropdown.styles';

function CustomDropdown({
  expanded,
  hideExpandedMenu,
  showLicenseWarning = false,
}) {
  const { navigate } = useNavigation();
  const { showDialog, removeDialog } = useDialog();

  const onLogoutPress = async () => {
    try {
      await serverLogoutUser({ jwt: await getAccessToken() });
      await localLogoutUser();
    } catch (_error) {
      await localLogoutUser();
    } finally {
      removeDialog();
    }
  };

  const onItemPress = useCallback((title) => {
    switch (title) {
      case 'Abmelden':
        showDialog(PREPARED_DIALOGS.logoutDialog(onLogoutPress));
        break;
      case 'Anleitung':
        navigate('Anleitung');
        break;
      case 'Kontakt':
        showDialog(PREPARED_DIALOGS.kontaktDialog());
        break;
      case 'Über die App':
        showDialog(PREPARED_DIALOGS.aboutNeolexonDialog());
        break;
      case 'Einwilligungen':
        navigate('Einwilligungen');
        break;
      case 'Mein Benutzerkonto':
        navigate('PatientAccount');
        break;
      case 'Ergebnisse ansehen':
        navigate('ResultsScreen');
        break;
      case 'Rezeptcode einlösen':
        navigate('DigaCodes');
        break;
      case 'Lizenz buchen':
        showDialog(PREPARED_DIALOGS.selectHealthInsuranceDialog(removeDialog));
        break;
    }
    hideExpandedMenu();
  }, []);

  return (
    !!expanded && (
      <TouchableWithoutFeedback onPress={hideExpandedMenu}>
        <SafeAreaView style={styles.overlay}>
          <View style={styles.menu}>
            <DropdownList
              onItemPress={onItemPress}
              items={getDropdownItems({ showLicenseWarning })}
            />
          </View>
        </SafeAreaView>
      </TouchableWithoutFeedback>
    )
  );
}

export default CustomDropdown;
